import URLS from './urls';

const LINKS = {
  ANCAP: 'https://www.ancap.com.au/',
  TAC: 'https://www.tac.vic.gov.au',
  VICTORIA_GOVERNMENT: 'https://www.vic.gov.au',
  PRIMARY: [
    { title: 'Safety features', url: URLS.SAFETY_FEATURES_LISTING },
    { title: 'Ratings explained', url: URLS.RATINGS },
  ],
  SECONDARY: [{ title: 'Contact', url: URLS.CONTACT_US }],
  TERMS_AND_PRIVACY: [
    { title: 'Privacy Policy', url: URLS.PRIVACY_POLICY },
    { title: 'Terms of use', url: URLS.TERMS_OF_USE },
    { title: 'Sitemap', url: URLS.SITEMAP },
  ],
} as const;

export type Link = (typeof LINKS)[keyof typeof LINKS];
export type LinkSet = (typeof LINKS)['PRIMARY'] | (typeof LINKS)['SECONDARY'] | (typeof LINKS)['TERMS_AND_PRIVACY'];

export default LINKS;
